const prod = {
    url : "https://pluxeema.prodexo.agency"
}
const dev = {
    url : "https://pluxeema.prodexo.agency"
}

export const MAX_AMOUNT = 50_000;
export const config = (process.env.REACT_APP_STAGE === 'dev') ? dev : prod;